import Card from '../ui/Card'

/**
 * EmptyNumberCard Component
 * Displays when no number is available with proper error messaging
 * Separated for better organization and reusability
 */
const EmptyNumberCard = ({ 
  errorMessage, 
  errorReason, 
  region 
}) => {
  return (
    <Card className="bg-white border-l-4 border-l-gray-400">
      <div className="text-center py-8">
        <div className="text-gray-500 mb-4">
          {errorMessage || 'কোন নম্বর পাওয়া যায়নি'}
          {region && (
            <div className="text-xs text-gray-400 mt-1">
              অঞ্চল: {region}
            </div>
          )}
        </div>
        <div className="text-sm text-gray-400">
          {errorReason || 'অনুগ্রহ করে একটু পরে আবার চেষ্টা করুন'}
        </div>
      </div>
    </Card>
  )
}

export default EmptyNumberCard